import React, { useState } from 'react';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import css from './SchoolPasswordInput.module.css';

function SchoolPasswordInput({ className, style, value, onChange, placeholder = 'Password', ...props }) {
  const [visible, setVisible] = useState(false);

  return (
    <div className={css.wrapper}>
      <input
        {...props}
        className={className}
        style={{ ...style, paddingRight: style?.paddingRight || '44px' }}
        type={visible ? 'text' : 'password'}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
      />
      <button
        type="button"
        className={css.toggle}
        onClick={() => setVisible(current => !current)}
        aria-label={visible ? 'Hide password' : 'Show password'}
        title={visible ? 'Hide password' : 'Show password'}
      >
        {visible ? <VisibilityOffIcon fontSize="small" /> : <VisibilityIcon fontSize="small" />}
      </button>
    </div>
  );
}

export default SchoolPasswordInput;
